import Switch from '@mui/material/Switch';
import { styled } from '@mui/material/styles';

const EnhancedSwitch = styled(Switch)(({ theme }) => ({
  width: 40,
  height: 20,
  padding: 0,
  display: 'flex',
  '& .MuiSwitch-switchBase': {
    padding: 4,
    '&.Mui-checked': {
      transform: 'translateX(19px)',
      color: theme.palette.common.white,
      '& + .MuiSwitch-track': {
        opacity: 1,
      },
    },
  },
  '& .MuiSwitch-thumb': {
    boxShadow: '0 2px 4px 0 rgb(0 35 11 / 20%)',
    width: 12,
    height: 12,
    borderRadius: '50%',
    transition: theme.transitions.create(['width'], {
      duration: 300,
    }),
  },
  '& .MuiSwitch-track': {
    borderRadius: 10,
    opacity: 1,
    backgroundColor: theme.palette.primary.main,
    boxSizing: 'border-box',
  },
}));

export default EnhancedSwitch;
